// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__33LCs","sendOtp":"AuthorizeToLogin_sendOtp__1ahL5"};